// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__30Qo6","subContainer":"styles_subContainer__1w_YW"};